// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d4f5de8","455":"3fb1b9ee"}[chunkId] + ".chunk.js";
};